import Telemetry from '@atlassian/mpac-telemetry';
import { useEffect } from 'react';
import { SearchResultPageTask, ViewSearchResult, viewSearchResultsTask } from '../../Telemetry/tasks';
export const useSearchPageTelemetry = _ref => {
  let {
    gridProps,
    searchQuery,
    commitOptions,
    commitSortKey
  } = _ref;
  useEffect(() => {
    SearchResultPageTask.start();
  }, []);
  useEffect(() => {
    ViewSearchResult.start();
  }, [searchQuery, commitOptions, commitSortKey]);
  useEffect(() => {
    if (gridProps.fetchMoreError || gridProps.initialFetchError) {
      const err = gridProps.initialFetchError || gridProps.fetchMoreError || new Error('No Search Result Data');
      Telemetry.setUFOInteractionError({
        name: viewSearchResultsTask,
        errorMessage: err
      });
      ViewSearchResult.failed(err);
    } else if (gridProps.rawData) {
      ViewSearchResult.succeeded();
    }
  }, [gridProps.fetchMoreError, gridProps.initialFetchError, gridProps.rawData]);
};